import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { Spauth } from './hooks/useSpauth.jsx';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Spauth appId="account-data-distributor-ui">
      <App />
    </Spauth>
  </StrictMode>
);
